export const formatPhoneNumber = (value, formatar) => {
  // Verificar se o valor é válido
  if (!value || typeof value !== 'string') {
    return formatar ? '' : '';
  }

  // Remove all non-digits
  let numbers = value.replace(/\D/g, '');
  
  // Se não deve formatar, retorna apenas os números
  if (!formatar) return numbers;

  // Limitar o comprimento máximo
  if (numbers.length > 11) {
    numbers = numbers.substring(0, 11);
  }

  // Format as (99) 99999-9999 or (99) 9999-9999
  if (numbers.length <= 10) {
    return numbers.replace(/(\d{2})(\d{0,4})(\d{0,4})/, (_, p1, p2, p3) => {
      let result = '';
      if (p1) result += `(${p1}`;
      if (p2) result += `) ${p2}`;
      if (p3) result += `-${p3}`;
      return result;
    });
  } else {
    return numbers.replace(/(\d{2})(\d{0,5})(\d{0,4})/, (_, p1, p2, p3) => {
      let result = '';
      if (p1) result += `(${p1}`;
      if (p2) result += `) ${p2}`;
      if (p3) result += `-${p3}`;
      return result;
    });
  }
};